import { PICKABLE_TYPES_DATA, PICKING_METHODS_DATA } from '../actions/actionType'

const initialState = {
  pickingMethods: [],
  pickableTypes: [],
}
export default function PickingMethodsReducer(state = initialState, action) {
  switch (action.type) {
    case PICKING_METHODS_DATA:
      return { ...state, pickingMethods: action.payload }
    case PICKABLE_TYPES_DATA:
      return { ...state, pickableTypes: action.payload }
    default:
      return state
  }
}
